import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Box } from "src/components/Box";
import { Button } from "src/components/Button";
import { Text } from "src/components/Text";
import { Breakpoint } from "src/components/Breakpoint";
import { ModalManager } from "src/components";
import { useTranslation } from "src/hooks";
import styled from "styled-components";
import { ArrowRight } from "@asphalt-react/iconpack";
import { PaymentMethodModal } from "./PaymentMethods.modal";
import { PaymentMethodCards } from "./PaymentMethods.cards";
import { Link } from "react-router-dom";
import { PASSPORT_ROUTES } from "src/constants/routes";
import { eventDispatcher } from "src/helpers/eventEmitter";
import { usePassportStore } from "src/stores";
import { skipEntityTypeScreen } from "src/helpers/skipEntityTypeScreen";

const DividerEl = styled(Box)`
  margin-bottom: 28px;
  background: rgb(230, 233, 239);
  height: 2px;
`;

export const PassportPaymentMethodsForm = observer(() => {
  const translate = useTranslation();
  const { outlet } = usePassportStore();

  const [modalState, setModalState] = useState(false);

  return (
    <Box>
      <Breakpoint medium up>
        <Text marginBottomXl fontSize="xlarge" fontWeight="demi">
          {translate("payment_methods.title")}
        </Text>
      </Breakpoint>
      <PaymentMethodCards />
      <Breakpoint medium up>
        <DividerEl />
      </Breakpoint>
      <Box flex justifyBetween>
        <Link to={PASSPORT_ROUTES.entityType}>
          {!skipEntityTypeScreen(outlet) && (
            <Button
              outline
              style={{ minWidth: "144px" }}
              onClick={() =>
                eventDispatcher.publish({ action: "ob_payment_previous" })
              }
            >
              {translate("payment_methods.cta.back")}
            </Button>
          )}
        </Link>
        <Button
          onClick={() => setModalState(true)}
          style={{ minWidth: "144px" }}
        >
          {translate("payment_methods.cta.continue")}
          &nbsp;&nbsp;&nbsp; <ArrowRight />
        </Button>
      </Box>
      <ModalManager
        scrollable
        showModal={modalState}
        onClose={() => setModalState(false)}
      >
        <PaymentMethodModal />
      </ModalManager>
    </Box>
  );
});
